export default __webpack_public_path__ + "static/media/hand_02.334be32d.png";